var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 0.875C2.16087 0.875 1.71575 1.05937 1.38756 1.38756C1.05937 1.71575 0.875 2.16087 0.875 2.625V11.375C0.875 11.8391 1.05937 12.2842 1.38756 12.6124C1.71575 12.9406 2.16087 13.125 2.625 13.125H11.375C11.8391 13.125 12.2842 12.9406 12.6124 12.6124C12.9406 12.2842 13.125 11.8391 13.125 11.375V2.625C13.125 2.16087 12.9406 1.71575 12.6124 1.38756C12.2842 1.05937 11.8391 0.875 11.375 0.875H2.625ZM3.58925 4.63487C3.86657 4.63488 4.13253 4.52471 4.32862 4.32862C4.52471 4.13253 4.63487 3.86657 4.63487 3.58925C4.63487 3.31193 4.52471 3.04597 4.32862 2.84988C4.13253 2.65379 3.86657 2.54363 3.58925 2.54363C3.31193 2.54363 3.04597 2.65379 2.84988 2.84988C2.65379 3.04597 2.54363 3.31193 2.54363 3.58925C2.54363 3.86657 2.65379 4.13253 2.84988 4.32862C3.04597 4.52471 3.31193 4.63487 3.58925 4.63487ZM4.46425 11.2114V5.45475H2.71425V11.2114H4.46425ZM5.62625 5.45475H7.37625V6.22563C7.63438 5.82137 8.20138 5.27713 9.25575 5.27713C10.514 5.27713 11.1974 6.111 11.1974 7.69737C11.1974 7.7735 11.2044 8.12088 11.2044 8.12088V11.2105H9.45438V8.12175C9.45438 7.69737 9.36512 6.8635 8.42188 6.8635C7.47775 6.8635 7.39813 7.91175 7.37625 8.59775V11.2105H5.62625V5.45475Z",
    fill: "#22AD01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGreen);
export default __webpack_public_path__ + "static/media/linkedin-green.9cafa962621b93cf526a3d7ab6fe9a60.svg";
export { ForwardRef as ReactComponent };